import {bp} from './namespace.js';
import './dashboard.js';
import './sessionstate.js';

$.extend(true, bp, {
  store: (function () {
    return {
      init_orderform_modal: function () {
        $('button.add-to-cart').click(function (e) {
          e.preventDefault();
          $.post(
            $(this).closest('form').attr('action'),
            $(this).closest('form').serialize(),
            function (result) {
              $('#modal .modal-content').html(result['modal_html']);
              if (result['status'] === 'ok') {
                bp.dashboard.set_advertisement_state(result['advertisement_pk']);
                bp.sessionstate.get_sessionstate();
              }
            }
          );
        });
      },
      remove_from_cart: function (advertisement_pk) {
        $.post(
          '/dashboard/winkelwagen/verwijderen/',
          {
            'estate_offer': advertisement_pk,
          },
          function () {
            location.reload();
          }
        );
      },
    };
  })(),
});

export {bp};
